import React from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '../config/app';

interface HeaderProps {
  onGetStarted?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onGetStarted }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <button
                onClick={() => navigate(APP_CONFIG.homepageUrl)}
                className="text-2xl font-bold text-blue-900 hover:text-blue-700 transition-colors cursor-pointer"
              >
                {APP_CONFIG.name}
              </button>
            </div>
          </div>

          {/* Start Your Application Button */}
          <div className="flex items-center">
            <button 
              onClick={onGetStarted}
              className="bg-blue-600 text-white px-6 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition-colors"
            >
              Start Your Application
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
